<template>
  <div :style="noticeVars">
    <!-- 图片模式：固定顶部 -->
    <div v-if="showNoticeBanner && currentNoticeImgUrl" :key="noticeIndex" class="notice-image-wrap">
      <img :src="currentNoticeImgUrl" class="notice-image" alt="通知公告" @click="goNoticeDetail" @load="onImageLoad" />
      <button class="notice-image__close" @click.stop="closeNoticeBanner">✕</button>
    </div>

    <!-- 文字模式：固定通知栏 -->
    <transition name="notice-banner-fade">
      <div v-if="showNoticeBanner && currentNotice && !currentNoticeImgUrl" class="notice-banner" @click="goNoticeDetail">
        <div class="notice-banner__inner">
          <div class="notice-banner__tag">📢 通知公告</div>
          <div class="notice-banner__divider"></div>
          <div class="notice-banner__body">
            <span class="notice-banner__title">{{ currentNotice.title }}</span>
            <span class="notice-banner__content" v-html="currentNotice.content"></span>
          </div>
          <div v-if="noticeList.length > 1" class="notice-banner__dots">
            <span
              v-for="(item, idx) in noticeList"
              :key="item.id"
              :class="['notice-banner__dot', { active: idx === noticeIndex }]"
              @click="noticeIndex = idx"
            ></span>
          </div>
          <button class="notice-banner__close" @click.stop="closeNoticeBanner">✕</button>
        </div>
      </div>
    </transition>

    <Header v-show="!isFull" />
    <div class="line"></div>
    <div class="page-content-wrapper">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view />
      </keep-alive>
      <router-view v-else />
    </div>
    <!-- <Login v-if="showLoginPane"></Login> -->
    <SidebarPart :paneFlag="paneFlag" v-show="!isFull"></SidebarPart>
    <Footer v-show="!isFull" />
    <!-- <Message></Message> -->
  </div>
</template>

<script>
import Footer from "./footer/Footer.vue";
import Header from "./header/Header.vue";
import Login from "@/views/Login/login.vue";
import SidebarPart from '@/views/Home/SidebarPart';
import { getBaseBizNoticeList } from "@/assets/API/home.js";
import define from "@/utils/define";
// import Message from '../Message'
import { mapState } from "vuex";
export default {
  name: "Layout",
  components: { Header, Footer, Login, SidebarPart },
  data() {
    return {
      paneFlag: false,
      previousScrollPosition: 0,
      // 通知公告
      noticeList: [],
      noticeIndex: 0,
      noticeBannerVisible: false,
      noticeHeight: 0,
      noticeTimer: null,
    };
  },
  computed: {
    currentNotice() {
      return this.noticeList[this.noticeIndex] || null;
    },
    // 登录相关页面不展示头部通知公告
    isLoginPage() {
      return /^\/(login|loginRetailer|logincopy)(\/|$)/.test(this.$route.path);
    },
    showNoticeBanner() {
      return this.noticeBannerVisible && !this.isLoginPage;
    },
    currentNoticeImgUrl() {
      const notice = this.currentNotice;
      if (!notice || !notice.imgUrl) return '';
      try {
        const parsed = JSON.parse(notice.imgUrl);
        const url = Array.isArray(parsed) ? parsed[0]?.url : parsed?.url;
        if (!url) return '';
        return /^https?:\/\//.test(url) ? url : define.APIURl + url;
      } catch (e) {
        return '';
      }
    },
    noticeVars() {
      let h = 0;
      if (!this.showNoticeBanner) {
        h = 0;
      } else if (this.currentNoticeImgUrl) {
        h = this.noticeHeight || 60;
      } else {
        h = 44;
      }
      return { '--notice-h': h + 'px' };
    },
    ...mapState("user", ["showLoginPane"]),
    isFull: {
      set(value) {
        this.$store.commit("isFull", value);
        if (value) {
          this.isFooter = false;
        }
      },
      get() {
        return this.$store.state.isFull;
      },
    },
    isFooter: {
      set(value) {
        this.$store.commit("isFooter", value);
      },
      get() {
        return this.$store.state.isFooter;
      },
    }
  },
  watch: {
    noticeIndex() {
      this.noticeHeight = 0;
    }
  },
  mounted() {
    console.log('uuuwwwww');
    window.addEventListener('scroll', this.handleScrollSidebar);
    this.fetchNoticeList();
    if (this.$route.path.includes("Retailer")) {
      this.$store.dispatch("user/getRetailerInfo");
    } else {
      this.$store.dispatch("user/getInfo");
    }

    let prop = this;
    window.onresize = function temp() {
      console.log("窗口变动了");
      if (!prop.utils.isFullScreen()) {
        if (!prop.$route.path.includes("Search") && !prop.$store.state.isFullScreen) {
          prop.isFull = false;
        }
      }
    };
  },
  methods: {
    fetchNoticeList() {
      try {
        getBaseBizNoticeList().then((res) => {
          console.log('[NoticeBanner] API response:', res);
          const list = (res && (res.data || res.list || res.result)) || [];
          const dataList = Array.isArray(list) ? list : (list.list || list.records || []);
          if (dataList.length > 0) {
            this.noticeList = dataList;
            if (this.noticeList.length > 0) {
              this.noticeBannerVisible = true;
              if (this.noticeList.length > 1) {
                this.noticeTimer = setInterval(() => {
                  this.noticeIndex = (this.noticeIndex + 1) % this.noticeList.length;
                }, 5000);
              }
            }
          }
        }).catch(e => {
          console.error('[NoticeBanner] API error:', e);
        });
      } catch (e) {}
    },
    closeNoticeBanner() {
      this.noticeBannerVisible = false;
      this.noticeHeight = 0;
      if (this.noticeTimer) clearInterval(this.noticeTimer);
    },
    onImageLoad(e) {
      this.noticeHeight = e.target.offsetHeight || e.target.naturalHeight || 0;
    },
    goNoticeDetail() {
      if (this.currentNotice && this.currentNotice.id) {
        this.$router.push({ path: '/NoticeDetail', query: { id: this.currentNotice.id } });
      }
    },
    handleScrollSidebar() {
      const currentScrollPosition = window.scrollY;
      if (currentScrollPosition > this.previousScrollPosition) {
        console.log("向下");
        // 向下滚动
        this.paneFlag = true;
        // 更新滚动位置
        this.previousScrollPosition = currentScrollPosition;
      } else if (currentScrollPosition < this.previousScrollPosition) {
        console.log("向上");
        // 向上滚动
        this.paneFlag = false;
        // 更新滚动位置
        this.previousScrollPosition = currentScrollPosition;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollSidebar);
    if (this.noticeTimer) clearInterval(this.noticeTimer);
  }
};
</script>

<style lang="scss" scoped>
// 通知图片模式（自然流式）
.notice-image-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  text-align: center;
  background: #fff;

  .notice-image {
    max-width: 100%;
    max-height: 200px;
    width: auto;
    object-fit: contain;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }

  .notice-image__close {
    position: absolute;
    right: 12px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: background 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.65);
    }
  }
}

// 通知文字模式（固定横幅）
.notice-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: linear-gradient(90deg, #1a2fcc 0%, #2d3ee0 40%, #0d27c8 100%);
  box-shadow: 0 4px 16px rgba(30, 50, 220, 0.35);

  &__inner {
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 10px 24px;
    height: 44px;
    box-sizing: border-box;
    gap: 14px;
  }

  &__tag {
    flex-shrink: 0;
    border: 2px solid #ff3b30;
    color: #ff3b30;
    font-size: 13px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 4px;
    white-space: nowrap;
  }

  &__divider {
    flex-shrink: 0;
    width: 1px;
    height: 22px;
    background: rgba(255, 255, 255, 0.3);
  }

  &__body {
    flex: 1;
    display: flex;
    align-items: baseline;
    gap: 12px;
    overflow: hidden;
    min-width: 0;
  }

  &__title {
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &__content {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__dots {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-shrink: 0;
  }

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    transition: background 0.2s;

    &.active { background: #fff; }
  }

  &__close {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.5);
    background: transparent;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    transition: background 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      color: #fff;
    }
  }
}

.notice-banner-fade-enter-active,
.notice-banner-fade-leave-active {
  transition: all 0.3s ease;
}
.notice-banner-fade-enter,
.notice-banner-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.page-content-wrapper {
  padding-top: calc(var(--notice-h, 0px));
  transition: padding-top 0.3s ease;
}

// .line {
// 	padding-top: 60px;
// }
</style>

<style lang="scss">
.summitek-header {
  top: var(--notice-h, 0px) !important;
  transition: top 0.3s ease;
}
</style>
